import React from 'react';
import ReactDOM from 'react-dom/client'; //react-router-dom
import reportWebVitals from './reportWebVitals';

import './index.css';

import Login from './pages/Login';

import Accueil from './pages/Accueil';
import Factures from './pages/Factures';
import Depenses from './pages/Depenses';

import Redirection from './components/Redirection';


import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Comptes from './pages/Comptes';

const root = ReactDOM.createRoot(document.getElementById('root'));

var tableauRouter = [{
  path: "*",
  element: <Login />,
}];
if (Redirection.getCookie("identifiant")) {
  tableauRouter = [
    {
      path: "/",
      element: <Accueil />,
    }, {
      path: "/accueil",
      element: <Accueil />,
    }, {
      path: "/gestion/factures",
      element: <Factures />,
    }, {
      path: "/gestion/depenses",
      element: <Depenses />,
    }, {
      path: "/compta",
      element: <Accueil />,
    }, {
      path: "/documents",
      element: <Accueil />,
    }, {
      path: "/direction",
      element: <Accueil />,
    }, {
      path: "/parametres",
      element: <Accueil />,
    }, {
      path: "/parametres/comptes",
      element: <Comptes />,
    }, {
      path: "/parametres/general",
      element: <Accueil />,
    }
  ]
}

console.log(Redirection.getCookie("identifiant"), tableauRouter)

const router = createBrowserRouter(tableauRouter);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
